import React, { Component } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import PageTitle from '../Misc/PageTitle';
import ContentLiveCard from '../Misc/ContentLiveCard';
import ContentStatsBar from '../Misc/ContentStatsBar';
import './Videos.css';

import DjiPhantomImg from '../../Assets/Img/dji-phantom-review.png';
import SqlServerImg from '../../Assets/Img/install-sql-server.png';
import AndroidNoJvmImg from '../../Assets/Img/android-no-jvm.PNG';
import Windows10PreviewImg from '../../Assets/Img/windows-10-preview.png';
import IcTablePreviewImg from '../../Assets/Img/ic-table.png';

const videos = [
  {
    img: DjiPhantomImg,
    title: 'DJI Phantom 3 Professional Drone Review',
    desc: 'Complete unboxing, flight setup, camera gimbal analysis, and initial impressions of the DJI Phantom 3 Quadcopter.',
    url: 'https://www.youtube.com/watch?v=6rFkiIx6qsw',
    category: 'Hardware Review',
    year: 'Review',
  },
  {
    img: SqlServerImg,
    title: 'Microsoft SQL Server 2014 Installation & Config',
    desc: 'Step-by-step tutorial on downloading, installing, and configuring Microsoft SQL Server 2014 Management Studio on Windows.',
    url: 'https://www.youtube.com/watch?v=szUmT11QYFM',
    category: 'Database Tutorial',
    year: 'Tutorial',
  },
  {
    img: AndroidNoJvmImg,
    title: 'Android Studio "No JVM Found" Installation Fix',
    desc: 'Resolving JDK environment variable path errors preventing Android Studio from booting on 64-bit systems.',
    url: 'https://www.youtube.com/watch?v=szUmT11QYFM',
    category: 'Developer Fix',
    year: 'Fix Guide',
  },
  {
    img: Windows10PreviewImg,
    title: 'Windows 10 Technical Preview Installation',
    desc: 'Detailed overview and setup walkthrough for the first Microsoft Windows 10 Technical Preview ISO installation.',
    url: 'https://www.youtube.com/watch?v=xqDO5t7L0_0',
    category: 'OS Walkthrough',
    year: 'Walkthrough',
  },
  {
    img: IcTablePreviewImg,
    title: 'IC-7432 OR Gate Truth Table Verification',
    desc: 'Hands-on digital logic laboratory experiment verifying Boolean logic states on a digital trainer kit.',
    url: 'https://www.youtube.com/watch?v=tPVYlMH3_E4',
    category: 'Computer Engineering',
    year: 'Lab Demo',
  },
];

class Videos extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  renderVideo = (video, idx) => (
    <ContentLiveCard
      key={video.title}
      img={video.img}
      badge={video.category}
      year={video.year}
      title={video.title}
      desc={video.desc}
      chromeLabel={{
        text: 'YouTube',
        icon: 'fa fa-youtube-play',
        className: 'sc-chrome-label--yt',
      }}
      links={[{
        href: video.url,
        label: 'Watch on YouTube',
        icon: 'fa fa-youtube-play',
        yt: true,
      }]}
      delay={idx * 80}
    />
  );

  render() {
    return (
      <div className="videos-page content-page">
        <Header />

        <main id="main-content" className="section-wrapper">
          <PageTitle
            eyebrow="Media &amp; Tutorials"
            pageTitle="Video Walkthroughs"
            subtitle="Technical guides, developer troubleshooting sessions, and technology hardware reviews published on YouTube."
          />

          <ContentStatsBar stats={[
            { value: 5, label: 'Videos' },
            { value: 4, label: 'Tutorials' },
            { value: 1, label: 'Review' },
          ]} />

          <div className="sc-sections">
            <section className="sc-section">
              <header className="sc-section-header">
                <h2 className="sc-section-title">Published Walkthroughs</h2>
                <p className="sc-section-desc">Step-by-step guides and reviews available on YouTube.</p>
              </header>
              <div className="sc-live-stack">
                {videos.map((video, idx) => this.renderVideo(video, idx))}
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    );
  }
}

export default Videos;
